/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Server-derived skeleton midline in image-pixel coords (snout→fork order),
 * kept for provenance/debug. The final length is the 3D arc through these
 * points; this is not the source of truth for the number, just its trace.
 * @export
 * @interface Midline2D
 */
export interface Midline2D {
    [key: string]: any | any;
    /**
     * 
     */
    points: Array<Array<number>>;
}

/**
 * Check if a given object implements the Midline2D interface.
 */
export function instanceOfMidline2D(value: object): value is Midline2D {
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function Midline2DFromJSON(json: any): Midline2D {
    return Midline2DFromJSONTyped(json, false);
}

export function Midline2DFromJSONTyped(json: any, ignoreDiscriminator: boolean): Midline2D {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'points': json['points'],
    };
}

export function Midline2DToJSON(json: any): Midline2D {
    return Midline2DToJSONTyped(json, false);
}

export function Midline2DToJSONTyped(value?: Midline2D | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'points': value['points'],
    };
}

